import styled from "styled-components";
import { BLACK, NOTICE_LIGHT } from "@streeteasy/design-system/colors";
import MenuPopup from "@streeteasy/design-system/legacy/MenuPopup";

import HeaderNavButton from "../HeaderNavButton";

export const NavListItem = styled.li`
  display: inline-block;
  line-height: 1.1;
  list-style: none;
  position: relative;
`;

export const ExpertsDropdownButton = styled(HeaderNavButton)`
  && {
    margin: 0 13px 0 19px;
    padding: 0;
  }
`;

export const ConnectionsCount = styled.span`
  color: ${BLACK};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  margin-left: 6px;

  &:after {
    color: ${NOTICE_LIGHT};
    content: "\f071";
    font-family: FontAwesome;
    font-size: 17px;
    margin-left: 2px;
  }
`;

export const CaretIcon = styled.i.attrs({
  className: "fa fa-angle-down"
})``;

export const StyledMenuPopup = styled(MenuPopup)`
  position: absolute;
  right: -10px;
  top: 100%;
  width: 220px;
  z-index: 10;
`;
